export const getUserPrefs = () => {
    if(localStorage.getItem("pref")) {
        return JSON.parse(localStorage.getItem("pref"));
    }
    return null;
}